// extracted by mini-css-extract-plugin
export default {"root":"TodoSection_root__N0H+l","title":"TodoSection_title__-EPlL","list":"TodoSection_list__BPj8W"};